import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import ServicesHero from './components/ServicesHero';
import AllServicesGrid from './components/AllServicesGrid';
import WhyChooseUs from './components/WhyChooseUs';

const ServiciosPage = () => {
  useEffect(() => {
    document.title = 'Servicios de Vaciado y Limpieza en Castelldefels | JUSTCLEAN';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Servicios profesionales de vaciado de pisos, locales, limpieza Diógenes, retirada de muebles y más en Castelldefels. Presupuesto gratis ☎️ 602 36 59 96');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Servicios de Vaciado y Limpieza",
      "provider": {
        "@type": "LocalBusiness",
        "name": "JUSTCLEAN CASTELLDEFELS",
        "telephone": "+34602365996",
        "email": "info@castelldefels.justclean.es",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Castelldefels",
          "addressRegion": "Barcelona",
          "addressCountry": "ES"
        }
      },
      "areaServed": {
        "@type": "City",
        "name": "Castelldefels"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Catálogo de Servicios",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vaciado de Pisos y Casas",
              "description": "Servicio completo de vaciado de viviendas con retirada de muebles, enseres y limpieza final"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vaciado de Locales Comerciales",
              "description": "Vaciado profesional de locales comerciales, oficinas y naves industriales"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Limpieza por Síndrome de Diógenes",
              "description": "Limpieza especializada en casos de acumulación compulsiva con tratamiento discreto y profesional"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Retirada de Muebles y Electrodomésticos",
              "description": "Recogida y gestión legal de residuos voluminosos con certificado de gestión"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Limpieza de Trasteros",
              "description": "Vaciado y limpieza completa de trasteros y espacios de almacenamiento"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Pintura Final",
              "description": "Servicio de pintura profesional para dejar el espacio listo para entregar"
            }
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-20">
        <ServicesHero />
        <AllServicesGrid />
        <WhyChooseUs />
      </div>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
};

export default ServiciosPage;
